// export const domain = "http://127.0.0.1:8072/api";
// export const url = "http://127.0.0.1:8072";
//
// export const domain = "https://tcdc-service.kisrasprint.com/api";
// export const url = "https://tcdc-service.kisrasprint.com/";
// LOCAL (docker: tcdc-api)
export const domain = "https://tcdc-api.ksta.co/api";
export const url = "https://tcdc-api.ksta.co/";

// PRODUCTION
// export const domain = "https://www.tcdc.or.th/v1/api";
// export const url = "https://www.tcdc.or.th/v1/";
